import { IState } from './CustomerPricingLookup.reducer';

export interface IActions {
    [CustomerPricingLookupActionTypes.setCalculatedData]?: IState['CalculatedData'];
    [CustomerPricingLookupActionTypes.setInitialCalculatordData]?: IState['InitialCalculatorData'];
}

export enum CustomerPricingLookupActionTypes {
    setCalculatedData = 'setCalculatedData',
    setInitialCalculatordData = 'setInitialCalculatorData'
}
